import { api } from "./client";

// External Intake & Collection v1.0 PR 9b §8.2 — staff approval queue
// HTTP client. Mirrors the BrokerApplicationDto contract from PR 9a.

export type BrokerApplicationStatus =
  | "Submitted"
  | "UnderReview"
  | "Approved"
  | "Declined"
  | "ChangesRequested";

export interface BrokerApplicationDto {
  id: string;
  brokerId: string;
  collectionPackageId: string;
  contactName: string;
  contactEmail: string;
  status: BrokerApplicationStatus;
  submittedAt: string;
  reviewedAt: string | null;
  reviewedByUserId: string | null;
  declineReason: string | null;
  reviewerNote: string | null;
  returnedAt: string | null;
}

export const brokerApplicationsApi = {
  list: (status: BrokerApplicationStatus = "Submitted") =>
    api.get<BrokerApplicationDto[]>("/brokers/applications", { status }),
  get: (id: string) => api.get<BrokerApplicationDto>(`/brokers/applications/${id}`),
  approve: (id: string, notes?: string) =>
    api.post<BrokerApplicationDto>(`/brokers/applications/${id}/approve`, { notes }),
  decline: (id: string, reason: string) =>
    api.post<BrokerApplicationDto>(`/brokers/applications/${id}/decline`, { reason }),
  return: (id: string, note: string) =>
    api.post<BrokerApplicationDto>(`/brokers/applications/${id}/return`, { note }),
};
